"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Map = require("@babel/runtime-corejs3/core-js-stable/map");

var _Promise = require("@babel/runtime-corejs3/core-js-stable/promise");

var _setTimeout = require("@babel/runtime-corejs3/core-js-stable/set-timeout");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.clearTimer = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var clearTimer = function clearTimer(config) {
  if (config.timer) {
    clearTimeout(config.timer);
  }
};

exports.clearTimer = clearTimer;

var toPromise = function toPromise(store) {
  return function (next) {
    var record = new _Map();
    return function (action) {
      var id = action._id;

      if (action.async) {
        var promise = new _Promise(function (resolve, reject) {
          var config = _objectSpread({}, action.async);

          if (config.loading) {
            var props = _objectSpread({}, action);

            delete props.async;
            delete props._id;
            config.timer = _setTimeout(function () {
              config.timer = null;
              store.dispatch(_objectSpread(_objectSpread({}, props), {}, {
                type: config.loading
              }));
            }, config.wait || 300);
          }

          if (config.resolve) {
            config.resolveFunc = resolve;
          }

          if (config.reject) {
            config.rejectFunc = reject;
          }

          record.set(id, config);
        });
        next(action);
        return promise;
      }

      var res = next(action);
      var config = record.get(id);

      if (config) {
        if (config.resolve === action.type) {
          clearTimer(config);
          config.resolveFunc(action);
          record["delete"](id);
        } else if (config.reject === action.type) {
          clearTimer(config);
          config.rejectFunc(action);
          record["delete"](id);
        }
      }

      return res;
    };
  };
};

var _default = toPromise;
exports["default"] = _default;